import { readonly, ref } from 'vue'

const isReportUpdated = ref(false)

export const usePeriodontalReport = (): any => {
  const setUpdateReport = (isUpdated: boolean) => {
    isReportUpdated.value = isUpdated
  }

  return {
    isReportUpdated: readonly(isReportUpdated),
    setUpdateReport,
  }
}
